<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";

const componentDetailsConfig = {
    cId: 'componentDetails',
    cType: "componentDetails",
    cTitle: "Component Details",
    showInCmpList: false,
    cTemplate: `<div v-if="componentId" class="component-details">
                    <div v-if="loading" class="loading-message">loading details</div>
                    <div v-if="!loading">
                        <tab-list cId="tabList_cmpdetails" :editor-enabled="editorEnabled"></tab-list>
                    </div>
                </div>
                `,
};

let componentDetailsCmp = {
    name: 'componentDetails',
    props: {
        componentId: {
            default: false
        }
    },
    data() {
        return {
            lastComponentId: false
        };
    },
    computed: {
        loading() {
            if (this.lastComponentId !== this.componentId) {
                setTimeout(() => {
                    this.lastComponentId = this.componentId;
                }, 1000); // NOSONAR
            }
            return this.lastComponentId && this.componentId !== this.lastComponentId;
        }
    },
    components: {
        "tabList": defineAsyncComponent(() => import('@common/tabList/tabList.vue')),
    }
};

componentStore.initComponent(componentDetailsCmp, componentDetailsConfig);
export default componentDetailsCmp;
</script>

<style scoped>
    .component-details {
        height: 100%;
        overflow: hidden;
    }
    :deep(.e-content > div) {
        margin:10px 0 10px 10px;
    }
    .e-content {
        max-height: 80%;
        overflow: auto;
    }
    .loading-message {
        padding: 20px;
        margin: 10px;
        text-align: center;
        font-weight: bold;
        background: #d3dfea;
        border: 1px solid #8cb8c9;
        color: #3a4358;
        border-radius: 4px;
        font-size: 16px;
    }
</style>
